module.exports = __webpack_public_path__ + "static/media/part-14.dbad96ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/part-14.jpg
// module id = 947
// module chunks = 0